import animateScroll from './animate-scroll';

$('.js-main-select').on('click', function() {
	const $this = $(this);
	const $selectedOption = $this.find('option:selected');
	const priceHtml = $selectedOption.data('price');
	const totalItems = $selectedOption.data('total-items');

	$('.js-change-price').html(priceHtml);
	changeQuantity(totalItems);
});

$('.js-main-select').on('change', function() {
	const $this = $(this);
	const $selectedOption = $this.find('option:selected');
	const priceHtml = $selectedOption.data('price');
	const totalItems = $selectedOption.data('total-items');

	$('.js-change-price').html(priceHtml);
	changeQuantity(totalItems);
});

$(window).on('load resize', function() {
	if ($('.js-select-width').length && $('.js-main-select').length) {
		const selectWidth = $('.js-select-width').outerWidth();

		$('.js-main-select').css({
			width: `${selectWidth}px`,
		});

		$('.js-select-container').addClass('initialized-select');
	}
});

$(window).on('load', function() {
	if ($('.current-image-variant').length && !$('[data-single-color]').length && $(window).width() >= 768) {

		animateScroll($('.current-image-variant'))
	}
});

function changeQuantity(quantityLimit) {
	let counter = 1;
	$('.js-select-quantity option').each(function() {
		const $currentOption = $(this);

		if (counter > quantityLimit) {
			$currentOption.attr('disabled', true);
		} else {
			$currentOption.removeAttr('disabled');
		}

		counter++;
	});
}

$('.js-select-container').on('change', function() {
	const selectedOption = $(this)
		.find('option:selected')
		.val();

	$('.js-product-images .product-image').each(function() {
		const $currentImageContainer = $(this);
		const dataString = $currentImageContainer
			.find('img')
			.data('image-variants')
			.toString();

		const dataArr = dataString.split(',');

		if (dataArr.indexOf(selectedOption) !== -1 && !$('[data-single-color]').length) {

			animateScroll($currentImageContainer)

			if ($(window).width() <= 767 && !$('[data-single-color]').length) {
				let slideNumber = $currentImageContainer.parents('.slick-slide').data('slick-index');
				$('.js-product-images').slick('slickGoTo', slideNumber);
			}
		}
	});
});
